import { render } from "./ModuloRol.vue?vue&type=template&id=51bbb9e2&scoped=true"
import script from "./ModuloRol.vue?vue&type=script&lang=js"
export * from "./ModuloRol.vue?vue&type=script&lang=js"

import "./ModuloRol.vue?vue&type=style&index=0&id=51bbb9e2&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\frontend.avicola\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51bbb9e2"]])

export default __exports__